let usage = `
<NotificationPopup
  v-model="notificationOpen"
  icon="check-circle"
  background-color="#1EB386"
  :message="message"
/>
`.slice(1);

export default {
  usage
};
